import { useEffect } from 'react';
export function getScript(url) {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = url;
        document.head.appendChild(script);
    });
}
function getStyle(url) {
    return new Promise((resolve, reject) => {
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.onload = resolve;
        link.onerror = reject;
        link.href = url;
        document.head.appendChild(link);
    });
}
async function loadCDNSource() {
    if (document.readyState !== 'complete') {
        await new Promise((resolve) => {
            window.addEventListener('load', () => {
                resolve('');
            });
        });
    }
    await new Promise((resolve) => setTimeout(resolve, 500));
    if (!window.React) {
        await getScript('https://gw.alipayobjects.com/os/lib/??react/16.8.6/umd/react.production.min.js');
    }
    if (!window.ReactDOM) {
        await getScript('https://gw.alipayobjects.com/os/lib/??react-dom/16.8.6/umd/react-dom.production.min.js');
    }
    // @ts-ignore
    if (!window.CNUI) {
        let { '@alife/cn-ui': cnuiVersion } = require('../../package.json').dependencies;
        cnuiVersion = cnuiVersion?.replace(/[~<>^=]/g, '');
        await Promise.all([getScript(`https://cn.alicdn.com/lib/cn-ui/cn-ui/${cnuiVersion}/dist/cn-ui.js`), getStyle(`https://cn.alicdn.com/lib/cn-ui/cn-ui/${cnuiVersion}/dist/cn-ui.css`)]);
    }
    // @ts-ignore
    if (!window.CNIntelliAssistant) {
        let { version, name } = require('../../package.json');
        const pkgName = name.split('/')[1];
        // @ts-ignore 辅助调试
        const prefixPath = `https://${window.isCnIntelliAssistantDev ? 'dev.' : ''}g.alicdn.com/code/npm/${name}/${version.split('-')[0]}/${pkgName}`;
        await Promise.all([getScript(`${prefixPath}.js`), getStyle(`${prefixPath}.css`)]);
    }
}
export const AsyncCnIntelliAssistant = function AsyncCnIntelliAssistant(props) {
    useEffect(() => {
        loadCDNSource().then(() => {
            // @ts-ignore
            if (!window.CNIntelliAssistantInstance) {
                // @ts-ignore
                window.CNIntelliAssistantInstance = window.CNIntelliAssistant?.setup?.(props);
            }
        });
        return () => {
            // @ts-ignore
            const { CNIntelliAssistantInstance } = window;
            if (CNIntelliAssistantInstance) {
                CNIntelliAssistantInstance.uninstall();
                // @ts-ignore
                delete window.CNIntelliAssistantInstance;
            }
        };
    }, [props.panelCode, props.userSystem]);
    return null;
};
let xReplayPromise = null;
export async function loadXReplay() {
    if (!xReplayPromise) {
        if (!window.React) {
            await getScript('https://gw.alipayobjects.com/os/lib/??react/16.8.6/umd/react.production.min.js');
        }
        if (!window.ReactDOM) {
            await getScript('https://gw.alipayobjects.com/os/lib/??react-dom/16.8.6/umd/react-dom.production.min.js');
        }
        const mediaSources = [
            'https://cn.alicdn.com/cn-ei-cto/media-resource/0.2.5/js/index.js',
            'https://cn.alicdn.com/cn-ei-cto/media-resource/0.2.5/xfeedback-api/2.5.3/index.js',
            'https://g.alicdn.com/xreplay/xreplay-api-publisher/0.30.1/xreplay-recorder-api.min.js',
        ];
        xReplayPromise = Promise.all(mediaSources.map(url => getScript(url)));
    }
    // console.log('xReplayPromise', xReplayPromise);
    await xReplayPromise.catch((err) => {
        console.error(err, 'xReplay load fail');
        xReplayPromise = null;
        throw err;
    });
}
